import { getEchartTooltipString } from "@/pages/dashboard/components/EchartsTooltip";
import { IColumn } from "@/pages/dashboard/components/EchartsTooltip/type";
import { getName } from "@home/utils/common";
import dataFormat from "@home/utils/dbDataFormat/dataFormat";

const getHorizontalBarTooltip = (props: any) => {
  const { params, tooltipConfig, isEn } = props || {};

  const { name } = params?.[0] || {};

  const { valueNameEn, valueNameCn, valueFormat = 'intBmk00' } = tooltipConfig || {};
  const valueName = getName(isEn, valueNameEn, valueNameCn);

  const tableData = params?.map((item: { value: string; seriesName: string; color: string; iconType: string; }) => {
    const { value, seriesName, color, iconType } = item;
    return { name: seriesName, value, color, iconType };
  });

  // 初步定义为头部为：日期、传入名称
  const columns: IColumn[] = [
    {
      key: 'name',
      header: name,
      showIcon: true,
    },
    {
      key: 'value',
      header: valueName,
      align: 'right',
      className: 'dbd-echarts-tooltip-container-number-text',
      render: (value: string) => {
        const valueText = dataFormat({
          value: Number(value || ''),
          formatRule: valueFormat,
        });
        return valueText;
      },
    },
  ];

  return getEchartTooltipString({
    table: {
      columns,
      data: tableData,
    },
  });
};

export default getHorizontalBarTooltip;
